const markApplyRecords = [
    {
        "id": "1",
        "applyDate": "2022-01-15T00:00:00.000+08",
        "labelStyle": "sticker",
        "appFormNo": "20210607-01",
        "personInCharge": "陳小花",
        "operatorName": "簡單生活開發有限公司",
        "totalApplyNumber": 3000,
        "passDate": "2022-03-15T00:00:00.000+08",
        "contactPerson": "Julia Shih",
        "contactPhone": "02-7723-8001",
        "fax": "02-7723-8002",
        "estimateUsePeriodStart": "2022-01-15T00:00:00.000+08",
        "estimateUsePeriodEnd": "2023-05-15T00:00:00.000+08",
        "shippingWay": "house",
        "whetherNeedToUploadRecord": true,
        "allowedOverprintMark": false,
        "labelDeliverAddress": {
            "zip": "11501",
            "city": "taipei",
            "district": "南港區",
            "street": "三重路19-11號5樓"
        },
        "pastDeliverAddress": [
            {
                "zip": "11008",
                "city": "taipei",
                "district": "信義區",
                "street": "市府路1號"
            },
            {
                "zip": "204",
                "city": "keelung",
                "district": "仁愛區",
                "street": "仁愛路11號1樓"
            }
        ],
        "applyItems": [
            {
                "productName": "1",
                "estimatedProduction": 200,
                "packingWeight": "150ml/瓶",
                "markNumber": 1000,
                "labelType": "單標章",
                "labelStyle": "sticker"
            },
            {
                "productName": "2",
                "estimatedProduction": 500,
                "packingWeight": "500g/罐",
                "markNumber": 1000,
                "labelType": "雙標章",
                "labelStyle": "sticker"
            }
        ],
        "applyDetailSummary": [
            {
                "labelType": "單標章",
                "applyNumber": 2000,
            },
            {
                "labelType": "雙標章",
                "applyNumber": 2000,
            },
            {
                "labelType": "轉型期",
                "applyNumber": 3000,
            }
        ]
    }
]

export default markApplyRecords